export const TIPO_ACCESO_WEB = 2;
export const ESTATUS_NO_VALIDADO = 2;
